const hasSalePurchaseOrderData = (row) =>
  Boolean(String(row?.purchase_order_code || '').trim())
  || Boolean(row?.purchase_order_received_date)
  || Boolean(row?.purchase_order_accepted_date)
  || Number(row?.purchase_order_amount || 0) > 0;

const hasSaleInvoiceData = (row) =>
  Boolean(String(row?.invoice_number || '').trim())
  || Number(row?.linked_document_count || 0) > 0
  || (Array.isArray(row?.linked_document_numbers) && row.linked_document_numbers.length > 0);

/** Venta explícita o histórica sin orden de compra. */
export const isSaleWithoutPurchaseOrder = (row) => {
  if (row?.has_purchase_order === false) return true;
  if (row?.has_purchase_order === true) return false;
  if (String(row?.quotation_status || '').trim() !== 'Vendida') return false;
  if (hasSalePurchaseOrderData(row)) return false;
  // Histórico: vendida sin OC ni factura → se cerró sin orden de compra.
  if (!hasSaleInvoiceData(row)) return true;
  return false;
};

export const resolveHasPurchaseOrder = (saleRow) => {
  if (saleRow?.has_purchase_order === true) return true;
  if (isSaleWithoutPurchaseOrder(saleRow)) return false;
  return Boolean(String(saleRow?.purchase_order_code || '').trim());
};

export const getSalePurchaseOrderFilterState = (row) => {
  if (isSaleWithoutPurchaseOrder(row)) return 'without_po';
  if (row?.has_purchase_order === true || hasSalePurchaseOrderData(row)) return 'with_po';
  return 'pending';
};

export const getSalePurchaseOrderLabel = (row) => {
  if (isSaleWithoutPurchaseOrder(row)) return 'Sin Orden de Compra';
  return String(row?.purchase_order_code || '').trim();
};
